import { IExtendedSearchData } from "src/api/server/extended-search.types";
import { SearchQueryParams } from "../search.types";
import { getSearchState, ISearchStore } from "../store/search-store";
import { mapKeyFiguresFromQuery, markKeyFiguresWithPopularIndication } from "./map-key-figures";
import { mapLeverageProductsIndicationFromQuery } from "./map-leverage-products-indication";
import { mapSelectedRankingFromQuery } from "./map-selected-ranking";
import { mapSortDirectionFromQuery } from "./map-sort-direction";
import { mapTagsFromQuery } from "./map-tags";
import { mapViewFromQuery } from "./map-view";

export const mapQueryStringToState = (urlParams: URLSearchParams, extendedSearchData: IExtendedSearchData): ISearchStore => {
    const sortDirectionParam = urlParams.get(SearchQueryParams.SortDirection);

    const sortDirection = sortDirectionParam ? mapSortDirectionFromQuery(sortDirectionParam) : null;
    const selectedRanking = mapSelectedRankingFromQuery(urlParams, sortDirection, extendedSearchData.rankingsData);
    const allKeyFigures = extendedSearchData.keyFiguresData.keyFiguresGroups.flatMap(keyFigureGroup => keyFigureGroup.keyFigures);
    const allKeyFiguresWithIsPopularIndication = markKeyFiguresWithPopularIndication(
        allKeyFigures,
        extendedSearchData.keyFiguresData.popularKeyFiguresGroup.keyFigures
    );

    const state: ISearchStore = {
        query: urlParams.get(SearchQueryParams.SearchTerm) ?? "",
        keyFigures: mapKeyFiguresFromQuery(urlParams, allKeyFiguresWithIsPopularIndication),
        tags: mapTagsFromQuery(urlParams, extendedSearchData.tagsData),
        selectedRanking: selectedRanking,
        sortDirection: sortDirection,
        brokersIds: urlParams.get(SearchQueryParams.BrokerIds)?.split(",") ?? [],
        isInvestable: urlParams.get(SearchQueryParams.IsInvestable) === "true",
        isAtInvestable: urlParams.get(SearchQueryParams.IsAtInvestable) === "true",
        isChInvestable: urlParams.get(SearchQueryParams.IsChInvestable) === "true",
        leverageProductsIndication: mapLeverageProductsIndicationFromQuery(urlParams),
        view: mapViewFromQuery(urlParams) ?? getSearchState().view,
        selectedFigures: getSearchState().selectedFigures,
        hasHydratedFromUrl: getSearchState().hasHydratedFromUrl,
    };

    return state;
};
